<rb-loading-spinner *ngIf="dataLoadingTable" class="spinner"></rb-loading-spinner>
	<!-- Notes of Vehicle -->
	<div class="row ms-2 me-2 mt-1 mb-1 ps-0 pe-0" *ngIf="!dataLoadingTable && !errorMessageTable">
		<div class="col-md-12 ps-0 pe-0">
			<div class="notesVehicle p-2">
				<h4 class="mt-2 mb-2">Vehicle of Note</h4>
				<div class="row ms-0 me-0 mt-1 mb-1">
                    <div class="col-md-2 ps-1 pe-1 d-flex align-items-end">
						<rb-form-input class="rb-input" placeholder="Search vehicles..." [(ngModel)]="searchQuery" (ngModelChange)="onSearchChange($event)" style="width:100%" />
                    </div>
                </div>
				<table class="m-table" *rbTable="loader; fixedHeaderWidth: false; columns: 5" [rbSort]="{id: 'agingClass', direction: 'asc'}" (rbSortChange)="onSortChange($event)">
					<thead>
							<tr>
									<th style="width: 15%;" rb-sort-header="name" [disableSortClear]="true">Asset Name</th>
									<th style="width: 15%;" rb-sort-header="vehicleModel" [disableSortClear]="true">Vehicle Model</th>
									<th style="width: 10%;" rb-sort-header="batteryStateOfHealth" [start]="'desc'" [disableSortClear]="true">State of Health</th>
									<th style="width: 10%;" rb-sort-header="agingClass" [start]="'asc'" [disableSortClear]="true">Aging Condition</th>
									<th style="width: 50%;">Usage Note</th>
							</tr>
					</thead>
					<tbody>
							<ng-container *ngFor="let vehicle of vehiclesList; let i = index">
									<tr *ngIf="((getStressLevel(vehicle,'Low Temperature Charging') || 0)>1 || (getStressLevel(vehicle,'Fast Charging') || 0)>1 || (getStressLevel(vehicle,'High State of Charge') || 0)>1 || (getStressLevel(vehicle,'Low State of Charge') || 0)>1 || (getStressLevel(vehicle,'High Temperature') || 0)>1) && vehicle.dataAvailable == true">
											<td style="width: 15%;">
												{{ vehicle.name ? vehicle.name : 'N/A' }}
												<br/>
												<br/>
												<button title="Insights" class="rb-btn rb-primary" (click)="goToInsights(vehicle.batteryIdentifier)">
													<span class="rb-ic rb-ic-document-search"></span>&nbsp;Ev Insights
												</button>
											</td>
											<td style="width: 15%;">{{ vehicle.vehicleModel ? vehicle.vehicleModel : 'N/A' }}</td>
											<td style="width: 10%;">
												{{ vehicle.batteryStateOfHealth ? (vehicle.batteryStateOfHealth | removeDecimalPoints:0) + '%' : 'N/A' }}
												<span
													*ngIf="vehicle.resultStatus === 'outdated'"
													class="rb-ic rb-ic-clock"
													[rbTooltip]="'Last datapoint: ' + (vehicle.timestamp ? (vehicle.timestamp | date:'dd MMM yyyy') : 'N/A')">
												</span>
											</td>
													<td style="width: 10%;" [ngStyle]="{
														'color': (vehicle.dataAvailable && vehicle.agingClass === 'average') ? 'var(--bosch-blue-50)' : 
															(vehicle.dataAvailable && vehicle.agingClass === 'above average') ? 'var(--bosch-green-50)' : 
															(vehicle.dataAvailable && vehicle.agingClass === 'below average') ? 'var(--bosch-purple-50)' : 
															'var(--bosch-black)'}">
														{{ ((vehicle.agingClass !== '' && vehicle.agingClass != null ) && vehicle.dataAvailable) ? vehicle.agingClass : 'N/A' }}</td>
											<td style="width: 50%;">
												<span *ngIf="(getStressLevel(vehicle,'Low Temperature Charging') || 0)>1" class="usage-note-row">
													<span 
														[ngStyle]="{'color': (getStressLevel(vehicle,'Low Temperature Charging') || 0) > 2 ? 'var(--bosch-yellow-80)' : 'var(--bosch-green-50)'}"
														[ngClass]="(getStressLevel(vehicle,'Low Temperature Charging') || 0) > 2 ? 'rb-ic rb-ic-alert-warning-filled': 'rb-ic rb-ic-alert-info-filled'">
													</span>
													<span class="usage-note-text">{{ getStressText(vehicle,'Low Temperature Charging') }}</span>
												</span>
												<br *ngIf="(getStressLevel(vehicle,'Low Temperature Charging') || 0)>1" />
												<span *ngIf="(getStressLevel(vehicle,'Fast Charging') || 0)>1" class="usage-note-row">
													<span
														[ngStyle]="{'color': (getStressLevel(vehicle,'Fast Charging') || 0) > 2 ? 'var(--bosch-yellow-80)' : 'var(--bosch-green-50)'}" 
														[ngClass]="(getStressLevel(vehicle,'Fast Charging') || 0) > 2 ? 'rb-ic rb-ic-alert-warning-filled': 'rb-ic rb-ic-alert-info-filled'">
													</span> 
													<span class="usage-note-text">{{ getStressText(vehicle,'Fast Charging') }}</span>
												</span>
												<br *ngIf="(getStressLevel(vehicle,'Fast Charging') || 0)>1" />
												<span *ngIf="(getStressLevel(vehicle,'High State of Charge') || 0)>1" class="usage-note-row">
													<span
														[ngStyle]="{'color': (getStressLevel(vehicle,'High State of Charge') || 0) > 2 ? 'var(--bosch-yellow-80)' : 'var(--bosch-green-50)'}"
														[ngClass]="(getStressLevel(vehicle,'High State of Charge') || 0) > 2 ? 'rb-ic rb-ic-alert-warning-filled': 'rb-ic rb-ic-alert-info-filled'">
													</span>
													<span class="usage-note-text">{{ getStressText(vehicle,'High State of Charge') }}</span>
												</span>
												<br *ngIf="(getStressLevel(vehicle,'High State of Charge') || 0)>1" />
												<span *ngIf="(getStressLevel(vehicle,'Low State of Charge') || 0)>1" class="usage-note-row">
													<span 
														[ngStyle]="{'color': (getStressLevel(vehicle,'Low State of Charge') || 0) > 2 ? 'var(--bosch-yellow-80)' : 'var(--bosch-green-50)'}"
														[ngClass]="(getStressLevel(vehicle,'Low State of Charge') || 0) > 2 ? 'rb-ic rb-ic-alert-warning-filled': 'rb-ic rb-ic-alert-info-filled'">
													</span>
													<span class="usage-note-text">{{ getStressText(vehicle,'Low State of Charge') }}</span> 
												</span>
												<br *ngIf="(getStressLevel(vehicle,'Low State of Charge') || 0)>1"/>
												<span *ngIf="(getStressLevel(vehicle,'High Temperature') || 0)>1" class="usage-note-row">
													<span
														[ngStyle]="{'color': (getStressLevel(vehicle,'High Temperature') || 0) > 2 ? 'var(--bosch-yellow-80)' : 'var(--bosch-green-50)'}"
														[ngClass]="(getStressLevel(vehicle,'High Temperature') || 0) > 2 ? 'rb-ic rb-ic-alert-warning-filled': 'rb-ic rb-ic-alert-info-filled'">
													</span>
													<span class="usage-note-text">{{ getStressText(vehicle,'High Temperature') }}</span>
												</span>
												<span *ngIf="
													((getStressLevel(vehicle,'Low Temperature Charging') || 0) < 2) &&
													((getStressLevel(vehicle,'Fast Charging') || 0) < 2) &&
													((getStressLevel(vehicle,'High State of Charge') || 0) < 2) &&
													((getStressLevel(vehicle,'Low State of Charge') || 0) < 2) &&
													((getStressLevel(vehicle,'High Temperature') || 0) < 2)
													">
												</span>
											</td>
									</tr>
							</ng-container>
					</tbody>
				</table>
				<div *ngIf="!hasVehiclesOfNote && (!vehiclesList || vehiclesList.length === 0)" class="mt-2">
					<rb-callout type="info">No vehicles of note found.</rb-callout>
				</div>
				<div *ngIf="hasVehiclesOfNote && (vehiclesList && vehiclesList.length > 0)" class="row m-0 mt-2">
					<div class="col-12 d-flex align-items-center justify-content-center">
						<rb-pagination [pageData]="pageData" (navigate)="navigateCall($event)"></rb-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="row ms-2 me-2 mt-1 mb-1 ps-0 pe-0" *ngIf="errorMessageTable && !dataLoadingTable">
		<rb-callout type="warning">
				No data for "Vehicle of Note" table.
		</rb-callout>
	</div>
